var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buttons m-b-15 m-lg-b-0 align-center"},_vm._l((_vm.fechas),function(fecha){return _c('b-button',{staticClass:"m-r-10",attrs:{"size":"lg","variant":_vm.active(fecha) ? 'primary' : 'outline-primary'},on:{"click":function($event){return _vm.clicked(fecha)}}},[_vm._v(" "+_vm._s(fecha)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }